export function downloadBlobFile(blob: Blob, filename: string) {
  // Create a temporary URL for the Blob object
  const url = window.URL.createObjectURL(blob);

  // Create a temporary anchor element
  const a = document.createElement('a');

  a.style.display = 'none'; // Hide the element
  a.href = url;
  a.download = filename; // Set the download filename

  a.click();
  a.remove();

  // Clean up by revoking the object URL
  window.URL.revokeObjectURL(url);
}
